export function getIsUserAvailable(isWgisSupportUser: boolean): boolean {
    return !isWgisSupportUser;
}
